import { ContractsModel } from '../../../types/contracts/contractsModel'
import { ContractsType } from './types'
import { SAVE_CONTRACTS } from './actionTypes'

const initialState: ContractsModel[] = []

const contracts = (
	state: ContractsModel[] = initialState,
	action: ContractsType
): Partial<ContractsModel>[] => {
	switch (action.type) {
		case SAVE_CONTRACTS: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default contracts
